import gql from "graphql-tag";

export const SEND_MAILGUN_TEST_EMAIL = gql`
  mutation SendMailgunTestEmail($to: String!) {
    sendMailgunTestEmail(to: $to) {
      configured
      domain
      fromEmail
      domainFound
      domainState
      domainIsActive
      senderMatchesDomain
      warnings
      message
    }
  }
`;

export interface SendMailgunTestEmailVariables {
  to: string;
}

export interface SendMailgunTestEmailResponse {
  sendMailgunTestEmail: {
    configured: boolean;
    domain: string;
    fromEmail: string;
    domainFound: boolean;
    domainState: string;
    domainIsActive: boolean;
    senderMatchesDomain: boolean;
    warnings: string[];
    message: string;
  };
}
